import isEmpty from 'lodash/isEmpty';
// import * as Sentry from '@sentry/browser';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import {
    Offline as OfflineIntegration,
    ExtraErrorData as ExtraErrorDataIntegration
} from '@sentry/integrations';
// import SentryRRWeb from '@sentry/rrweb';

Sentry.init({
    dsn: process.env.MIX_SENTRY_DSN,
    environment: process.env.MIX_APP_ENV,
    maxBreadcrumbs: 100,
    sampleRate: 1.0,
    tracesSampleRate: 1.0,
    integrations: [
        new BrowserTracing({}),
        // new SentryRRWeb({}),
        new ExtraErrorDataIntegration({}),
        new OfflineIntegration({})
    ],
    denyUrls: [
      // Google Adsense
      /pagead\/js/i,
    ],
    ignoreErrors: [
        // Random plugins/extensions
        'top.GLOBALS'
        // 'No slot size for'
    ]
    // ignoreUrls: [
    //     'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js',
    //     'https://accounts.google.com/gsi/client'
    // ]
});

let user = null;
if (window.App && window.App.user) {
    user = window.App.user;
}

if (!isEmpty(user)) {
    let model = {
        id: user.id,
        name: user.name
        // ip_address: request.ip_address
    };

    if (!isEmpty(user.email)) {
        model.email = user.email;
    }

    Sentry.configureScope(function (scope) {
        scope.setUser(model);
    });
}

window.Sentry = Sentry;
